import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import type { MultiSelectOptionGroup } from "@/components/MultiSelectDropdown"
import type { AdsManagerColumn } from "../lib/columns"
import { FilterBar } from "./FilterBar"

interface FiltersMobileDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  userGroups: MultiSelectOptionGroup<number>[]
  selectedUserIds: number[]
  onUserIdsChange: (ids: number[]) => void
  selectedAccountIds: string[]
  onAccountIdsChange: (ids: string[]) => void
  accountGroups: MultiSelectOptionGroup<string>[]
  columns: readonly AdsManagerColumn[]
  hiddenColumns: Set<string>
  onToggleColumn: (columnId: string) => void
}

export function FiltersMobileDialog({
  open,
  onOpenChange,
  ...filterProps
}: FiltersMobileDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[85dvh] overflow-y-auto border-[#4a4a4a] bg-[#2d2d2d] text-white sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-white">Filters</DialogTitle>
          <DialogDescription className="text-[#b0b0b0]">
            Refine campaigns by account, user, and visible columns. Status is
            filtered from the Status column header.
          </DialogDescription>
        </DialogHeader>
        <FilterBar layout="stacked" {...filterProps} />
      </DialogContent>
    </Dialog>
  )
}
